export const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const cartItemKey = (item) => JSON.stringify(
  [item.productId, item.sku, item.size, item.color, item.variation].map((value) => value ?? "")
);

export const validDiscount = (discount) => discount &&
  Number.isInteger(Number(discount.quantity)) && Number(discount.quantity) > 0 &&
  Number.isFinite(Number(discount.percentage)) && Number(discount.percentage) >= 0 && Number(discount.percentage) <= 100;

export const unitPrice = (item, quantity = item.quantity) => {
  const price = Number(item.basePrice ?? item.originalPrice ?? item.price);
  if (!Number.isFinite(price) || price < 0) return 0;
  const discount = item.quantityDiscount;
  return roundMoney(validDiscount(discount) && quantity >= Number(discount.quantity)
    ? price * (1 - Number(discount.percentage) / 100) : price);
};

export const cartSubtotal = (items) => roundMoney(items.reduce((total, item) => total + unitPrice(item) * item.quantity, 0));
export const formatMoney = (value) => new Intl.NumberFormat("sv-SE", {
  style: "currency", currency: "SEK", maximumFractionDigits: 2,
}).format(Number(value) || 0);

export const productStock = (product) => {
  if (product?.isOutOfStock) return 0;
  if (Number.isFinite(Number(product?.stock)) && product?.stock != null) {
    return Math.max(0, Math.floor(Number(product.stock)));
  }
  if (Array.isArray(product?.stock?.stocks)) {
    return product.stock.stocks.reduce((total, row) => total + Math.max(0, Math.floor(Number(row.quantity) || 0)), 0);
  }
  return 0;
};
